import React, { useEffect, useRef } from 'react';
;
export var Modal = function (_a) {
    var show = _a.show, title = _a.title, footer = _a.footer, onClose = _a.onClose, setShow = _a.setShow, children = _a.children, className = _a.className, _b = _a.showClose, showClose = _b === void 0 ? true : _b;
    var isOpened = useRef(false);
    useEffect(function () {
        var bodyElement = document.body;
        if (show) {
            bodyElement.classList.add('o-hidden');
            isOpened.current = true;
        }
        else {
            if (isOpened.current) {
                bodyElement.classList.remove('o-hidden');
                isOpened.current = false;
            }
        }
        return function () {
            bodyElement.classList.remove('o-hidden');
        };
    }, [show]);
    var onModalClose = function () {
        setShow && setShow(false);
        onClose && onClose();
    };
    return (React.createElement(React.Fragment, null, show && (React.createElement("div", { className: "modal-overlay" },
        React.createElement("div", { className: "modal " + (className || '') },
            showClose &&
                React.createElement("div", { className: "close", onClick: onModalClose }, "\u00D7"),
            title && (React.createElement("div", { className: "modal-head" }, title)),
            React.createElement("div", { className: "modal-content" }, children),
            footer && (React.createElement("div", { className: "modal-foot" }, footer)))))));
};
